import React from 'react';
import styles from './Contacts.module.scss';

const Contacts = () => {
  return (
    <div className={styles.contacts}>
      <div className={styles.contacts__about}>
        <h3 className={styles.contacts__title}>Про нас:</h3>
        <p className={styles.contacts__text}>
          ФА — это современное приложение для контроля финансов, целей и
          привычек. Проект создаётся с фокусом на UX, визуальную эстетику и
          осознанное управление деньгами.
        </p>
        <div className={styles.contacts__tech}>
          <p className={styles.contacts__version}>0.9.8</p>
          <p className={styles.contacts__status}>Статус: Бета</p>
          <p className={styles.contacts__year}>© 2026</p>
        </div>
      </div>

      <div className={styles.contacts__block}>
        <h3 className={styles.contacts__title}>Связаться с нами:</h3>
        <div className={styles.contacts__links}>
          <a
            href='https://t.me/ArtGora'
            target='_blank'
            className={styles.contact__link}>
            Телеграм @artgora
          </a>
          <a
            href='mailto:nagorskiyartem@gmail.com'
            target='_blank'
            className={styles.contact__link}>
            nagorskiyartem@gmail.com
          </a>
        </div>
        <div className={styles.legal}>
          <a href='' className={styles.legal__link}>
            Политика конфиденциальности
          </a>
          <a href='' className={styles.legal__link}>
            Пользовательское соглашение
          </a>
        </div>
      </div>
    </div>
  );
};

export default Contacts;
